import { defineMessages } from '@atlassian/jira-intl';

const messages = defineMessages({
	loomRecordVideoButtonLabel: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-record-video-button-label',
		defaultMessage: 'Record a video',
		description: 'The label to be used on the button for showing record video options',
	},
	loomAdImageAltNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-image-alt-no-translate',
		defaultMessage:
			'“A man records his screen. A small circle shows his face so that he can add his own commentary.”',
		description: 'The graphic that is shown in the Loom ad',
	},
	loomAdTryNowNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-try-now-no-translate',
		defaultMessage: 'Try now',
		description: 'The call to action in the Loom ad',
	},
	loomAdHeadingNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-heading-no-translate',
		defaultMessage: 'Record a video',
		description: 'The heading in the Loom ad',
	},
	loomAdBodyNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-body-no-translate',
		defaultMessage: "Share a demo of the work you're doing.",
		description: 'The body in the Loom ad',
	},
	loomAdAdControlsReasonsNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-reasons-no-translate',
		defaultMessage: 'Why am I seeing this?',
		description: 'Title of the ad control reasons modal in the Loom ad',
	},
	loomAdAdControlsDismissFlagTitleNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-dismiss-flag-title-no-translate',
		defaultMessage: 'Thanks for letting us know',
		description: 'Title of the flag that shows up when a user dismisses the Loom ad',
	},
	loomAdAdControlsReasonsModalExplanationNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-reasons-modal-explanation-no-translate',
		defaultMessage:
			"We think <strong>Loom</strong> will improve your team's productivity. The recommendation is based on:",
		description: 'Explanation as to why the Loom ad is being shown',
	},
	loomAdAdControlsReasonsModalBulletOneNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-reasons-modal-bullet-one-no-translate',
		defaultMessage: 'the size of your team',
		description: 'First bullet point of the reasons modal',
	},
	loomAdAdControlsReasonsModalBulletTwoNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-reasons-modal-bullet-two-no-translate',
		defaultMessage: 'your existing Atlassian products',
		description: 'Second bullet point of the reasons modal',
	},
	loomAdAdControlsPrivacyPolicyNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-privacy-policy-no-translate',
		defaultMessage: 'Learn more about your data privacy with Atlassian',
		description: "Link to Atlassian's privacy policy",
	},
	loomAdControlsAdDismissedFlagTitleNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-controls-ad-dismissed-flag-title-no-translate',
		defaultMessage: 'Thanks for letting us know',
		description:
			'The title of the flag that is displayed when the user permanently dismisses the Loom ad',
	},
	loomAdAdControlsDismissFlagDescriptionNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.loom-ad-ad-controls-dismiss-flag-description-no-translate',
		defaultMessage: "You won't be seeing this here anymore",
		description: 'Description of the flag that shows up when a user dismisses the Loom ad',
	},
	headingNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.heading-no-translate',
		description: 'Heading for loom benefits modal feature',
		defaultMessage: 'Record and share a video',
	},
	contextToAnythingFeatureNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.context-to-anything-feature-no-translate',
		description: 'Feature text for looms benefits modal',
		defaultMessage: 'Add context to anything, from code reviews to demos',
	},
	updateYourTeamNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.update-your-team-no-translate',
		description: 'Feature text for looms benefits modal',
		defaultMessage: 'Easily update your team without a meeting',
	},
	freeTrialNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.free-trial-no-translate',
		description: 'Feature text for looms benefits modal',
		defaultMessage: "14 day free trial (we'll remind you before it ends)",
	},
	cancelNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.cancel-no-translate',
		description: 'A label for the button that allows users to cancel their subscription.',
		defaultMessage: 'Cancel',
	},
	getStartedNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.get-started-no-translate',
		description: 'A label for CTA button that allows users to confirm .',
		defaultMessage: 'Get started',
	},
	imageAltTextNoTranslate: {
		id: 'issue-view-foundation.quick-add.loom-record-item-ad.image-alt-text-no-translate',
		description: 'Alternate text displayed under the background and video',
		defaultMessage:
			'A woman records her screen. A small circle shows her face so that she can add her own commentary.',
	},
});

export default messages;
